export default __webpack_public_path__ + "static/media/blog-1.dff7ef72.jpg";